/*
 * ============================================================================
 * lumiere-deferred-video  … ルミエール専用（テーマ変更時は一緒に移設する）
 * ============================================================================
 * 【用途】
 * sections/lumiere-video.liquid の動画枠で使うカスタム要素。
 * ページ表示時点では YouTube の iframe を一切作らず、カバー画像＋再生ボタン
 * だけを見せる（いわゆる Lite YouTube Embed）。再生ボタンが押された瞬間に
 * 画面幅を判定し、そのデバイスに必要な iframe を「1本だけ」生成する。
 *
 * 【なぜ Dawn の <deferred-media> を使わないか】
 * Dawn の実装は <template> に書いた iframe をそのまま複製するだけなので、
 * PC用とSP用を出し分けられない。かといって両方HTMLに出して display:none で
 * 隠すと、非表示側のYouTubeまで読み込まれてページ速度が落ちる。
 *
 * 【HTML側に必要なもの】（詳細は sections/lumiere-video.liquid 参照）
 *   data-video-url          PC用の埋め込みURL（必須）
 *   data-video-url-mobile   SP用の埋め込みURL（任意。未指定ならPC用を使う）
 *   data-mobile-media-query SP判定の条件。既定は (max-width: 749px)
 *   data-video-title        iframe の title 属性に入れる説明文
 *   子要素に id="Deferred-Poster-..." のボタン（これがクリック起点になる）
 *
 * 【他の仕組みとの連携】
 * ・生成する iframe に js-youtube を付けている。これは Dawn の
 *   window.pauseAllMedia() が停止対象を探すための目印で、他の動画を再生した
 *   ときにこちらが止まるようにしている。
 * ・読み込み後は loaded 属性を付ける。Dawn の component-deferred-media.css が
 *   これを見てカバー画像を隠す。
 * ・要素名を変えたことで base.css の「deferred-media { display: block }」が
 *   効かなくなるため、display:block はセクション側のCSSで指定している。
 * ============================================================================
 */
if (!customElements.get('lumiere-deferred-video')) {
  class LumiereDeferredVideo extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this, true));
    }

    // 今どちらの動画を読むべきか。SP用URLが登録されていて、かつ画面がSP幅の
    // ときだけSP用。それ以外（PC、またはSP用が未登録）は必ずPC用になる。
    get videoUrl() {
      const mobileUrl = this.dataset.videoUrlMobile;
      const mobileQuery = this.dataset.mobileMediaQuery || '(max-width: 749px)';
      if (mobileUrl && window.matchMedia(mobileQuery).matches) return mobileUrl;
      return this.dataset.videoUrl;
    }

    loadContent(focus = true) {
      // 他の動画が再生中なら止める（Dawn共通の関数。無い環境でも動くようにガード）
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      // 2回目以降のクリックでiframeを重複生成しない
      if (this.getAttribute('loaded')) return;

      const src = this.videoUrl;
      if (!src) return;

      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('class', 'js-youtube');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      iframe.setAttribute('allowfullscreen', 'allowfullscreen');
      iframe.setAttribute('title', this.dataset.videoTitle || '');

      this.setAttribute('loaded', true);
      this.appendChild(iframe);
      if (focus) iframe.focus();
    }
  }

  customElements.define('lumiere-deferred-video', LumiereDeferredVideo);
}
